import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './tfli.png'


const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "email-journey-notice"
}
const _hoisted_4 = { class: "timeline-container" }
const _hoisted_5 = { class: "timeline" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "timeline-content" }
const _hoisted_8 = { class: "step-description" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = {
  key: 0,
  class: "input-wrapper"
}
const _hoisted_11 = {
  key: 0,
  class: "name-inputs"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["onUpdate:modelValue", "type", "inputmode", "pattern", "placeholder", "onInput", "disabled"]
const _hoisted_15 = {
  key: 2,
  class: "password-input-wrapper"
}
const _hoisted_16 = ["type", "disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 1,
  class: "company-inputs"
}
const _hoisted_19 = { class: "business-type-toggle" }
const _hoisted_20 = {
  key: 0,
  class: "company-search"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "search-loading"
}
const _hoisted_23 = {
  key: 1,
  class: "search-error"
}
const _hoisted_24 = {
  key: 2,
  class: "search-results"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "company-name" }
const _hoisted_27 = { class: "company-details" }
const _hoisted_28 = { class: "company-address" }
const _hoisted_29 = { class: "company-number" }
const _hoisted_30 = ["placeholder", "disabled"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 0,
  class: "button-group"
}
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "button-loading"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "toast-icon" }
const _hoisted_39 = { class: "toast-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createStaticVNode("<header class=\"tfli-header\"><div class=\"header-content\"><div class=\"logo-container\"><div class=\"logo swoop-logo\"><a href=\"https://swoopfunding.com\" target=\"_blank\" rel=\"noopener noreferrer\"><img src=\"https://swoopfunding.com/wp-content/themes/swoopMW50/assets/images/swoop-color.svg\" alt=\"Swoop Funding\"></a></div><div class=\"logo-separator\"><span class=\"partnership-text\">in partnership with</span></div><div class=\"logo tfli-logo\"><img src=\"" + _imports_0 + "\" alt=\"TFLI - The Funding and Lending Institute\"></div></div></div></header>", 1)),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasUrlParamsAutofill)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[20] || (_cache[20] = [
              _createElementVNode("h3", null, "Welcome back!", -1),
              _createElementVNode("p", null, "Final step… Please review your details below and create a password to access your funding matches.", -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(["timeline-step", {
                'active': _ctx.currentStep === index,
                'completed': _ctx.isStepCompleted(index),
                'upcoming': _ctx.currentStep < index && !_ctx.hasUrlParamsAutofill,
                'has-error': _ctx.validationErrors[step.id] && (_ctx.currentStep >= index || _ctx.hasUrlParamsAutofill),
                'has-url-params': _ctx.hasUrlParamsAutofill
              }]),
                onClick: ($event: any) => (_ctx.handleStepClick(index))
              }, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "timeline-marker" }, null, -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h2", null, _toDisplayString(step.title), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(step.description), 1),
                  _createElementVNode("div", _hoisted_9, [
                    (step.type === 'text' && step.field)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (step.id === 'name')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.firstName) = $event)),
                                  type: "text",
                                  placeholder: "First Name",
                                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                                  disabled: _ctx.currentStep < index && !_ctx.hasUrlParamsAutofill,
                                  class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.firstName })
                                }, null, 42, _hoisted_12), [
                                  [_vModelText, _ctx.formData.firstName]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lastName) = $event)),
                                  type: "text",
                                  placeholder: "Last Name",
                                  onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                                  disabled: _ctx.currentStep < index && !_ctx.hasUrlParamsAutofill,
                                  class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.lastName })
                                }, null, 42, _hoisted_13), [
                                  [_vModelText, _ctx.formData.lastName]
                                ])
                              ]))
                            : (step.field !== 'password')
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.formData[step.field as keyof FormData]) = $event),
                                  type: step.inputType || 'text',
                                  inputmode: step.inputMode,
                                  pattern: step.pattern,
                                  placeholder: step.placeholder,
                                  onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                                  onInput: ($event: any) => (_ctx.handleNumericInput(step.field, $event)),
                                  disabled: _ctx.currentStep < index && !_ctx.hasUrlParamsAutofill,
                                  class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData[step.field as keyof FormData] })
                                }, null, 42, _hoisted_14)), [
                                  [_vModelDynamic, _ctx.formData[step.field as keyof FormData]]
                                ])
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.password) = $event)),
                                    type: _ctx.showPassword ? 'text' : 'password',
                                    placeholder: "Password",
                                    onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                                    disabled: _ctx.currentStep < index && !_ctx.hasUrlParamsAutofill,
                                    class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.password })
                                  }, null, 42, _hoisted_16), [
                                    [_vModelDynamic, _ctx.formData.password]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "toggle-password",
                                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showPassword = !_ctx.showPassword), ["stop"])),
                                    type: "button",
                                    disabled: _ctx.currentStep < index && !_ctx.hasUrlParamsAutofill
                                  }, _toDisplayString(_ctx.showPassword ? 'Hide' : 'Show'), 9, _hoisted_17)
                                ]))
                        ]))
                      : _createCommentVNode("", true),
                    (step.type === 'company')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: _ctx.formData.businessType === 'limited' }),
                              onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.formData.businessType = 'limited'), ["stop"]))
                            }, " Limited Company ", 2),
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: _ctx.formData.businessType === 'sole' }),
                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.formData.businessType = 'sole'), ["stop"]))
                            }, " Sole Trader ", 2)
                          ]),
                          (_ctx.formData.businessType === 'limited')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.companyName) = $event)),
                                  type: "text",
                                  placeholder: "Search for your company",
                                  onInput: _cache[11] || (_cache[11] = (e) => _ctx.searchCompanies((e.target as HTMLInputElement).value)),
                                  disabled: _ctx.currentStep !== index && !_ctx.hasUrlParamsAutofill,
                                  class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.companyName })
                                }, null, 42, _hoisted_21), [
                                  [_vModelText, _ctx.formData.companyName]
                                ]),
                                (_ctx.formData.isSearching)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Searching... "))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.searchError)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.formData.searchError), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.formData.companySearchResults?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.companySearchResults, (company) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: company.company_number,
                                          class: "search-result-item",
                                          onClick: _withModifiers(($event: any) => (_ctx.selectCompany(company)), ["stop"])
                                        }, [
                                          _createElementVNode("div", _hoisted_26, _toDisplayString(company.title || company.company_name), 1),
                                          _createElementVNode("div", _hoisted_27, [
                                            _createElementVNode("div", _hoisted_28, _toDisplayString(company.address?.premises) + " " + _toDisplayString(company.address?.address_line_1) + " " + _toDisplayString(company.address?.locality ? `, ${company.address.locality}` : '') + " " + _toDisplayString(company.address?.region ? `, ${company.address.region}` : '') + " " + _toDisplayString(company.address?.postal_code ? `, ${company.address.postal_code}` : ''), 1),
                                            _createElementVNode("div", _hoisted_29, "Company number: " + _toDisplayString(company.company_number), 1),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["company-status", company.company_status.toLowerCase()])
                                            }, _toDisplayString(company.company_status), 3)
                                          ])
                                        ], 8, _hoisted_25))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.companyName) = $event)),
                            type: "text",
                            placeholder: _ctx.formData.businessType === 'limited' ? 'Company Name' : 'Business Name',
                            onKeyup: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                            disabled: _ctx.currentStep !== index && !_ctx.hasUrlParamsAutofill,
                            class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.companyName })
                          }, null, 42, _hoisted_30), [
                            [_vModelText, _ctx.formData.companyName]
                          ]),
                          (_ctx.formData.businessType === 'limited')
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.registrationNumber) = $event)),
                                type: "text",
                                placeholder: "Registration Number (8 digits)",
                                onKeyup: _cache[15] || (_cache[15] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                                disabled: _ctx.currentStep !== index && !_ctx.hasUrlParamsAutofill,
                                class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.registrationNumber })
                              }, null, 42, _hoisted_31)), [
                                [_vModelText, _ctx.formData.registrationNumber]
                              ])
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.postcode) = $event)),
                            type: "text",
                            placeholder: "Postcode",
                            onKeyup: _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["enter"])),
                            disabled: _ctx.currentStep !== index && !_ctx.hasUrlParamsAutofill,
                            class: _normalizeClass({ 'error': _ctx.validationErrors[step.id] && !_ctx.formData.postcode })
                          }, null, 42, _hoisted_32), [
                            [_vModelText, _ctx.formData.postcode]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.currentStep === index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        (index > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)), ["stop"])),
                              class: "secondary"
                            }, " Back "))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)), ["stop"])),
                          disabled: !_ctx.isStepValid || (index === _ctx.steps.length - 1 && _ctx.isSubmitting)
                        }, [
                          (index === _ctx.steps.length - 1 && _ctx.isSubmitting)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _cache[21] || (_cache[21] = [
                                _createElementVNode("span", { class: "spinner" }, null, -1),
                                _createElementVNode("span", null, "Processing...", -1)
                              ])))
                            : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(index === _ctx.steps.length - 1 ? 'See funding now' : 'Next'), 1))
                        ], 8, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.error && _ctx.currentStep === index)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "error-message",
                        innerHTML: _ctx.error
                      }, null, 8, _hoisted_37))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_6))
            }), 128))
          ])
        ])
      ])
    ]),
    (_ctx.verificationNotice)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["toast-notification", _ctx.verificationNotice.type])
        }, [
          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.verificationNotice.icon), 1),
          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.verificationNotice.message), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}